import { ReservationFlowCustomerFieldItem } from '../../../../interfaces/reservation_flow';
import {
  regexpAlphanumeric,
  regexpNumeric,
  regexpPhone,
  regexpEmail,
  regexpKatakana,
} from '../../../../libs/reservation-flow/regex';

export const validateCustomerInfo: (
  item: ReservationFlowCustomerFieldItem,
  value: string | undefined,
) => { isValid: true } | { isValid: false; type: 'required' | 'format' } = (
  item,
  value,
) => {
  if (item.is_required) {
    if (typeof value === 'undefined' || value.length === 0) {
      return { isValid: false, type: 'required' };
    }
  }

  // is_required: false かつ valueがundefinedもしくは空文字列もしくは空配列の場合は、validateしない
  if (typeof value === 'undefined' || value.length === 0) {
    return { isValid: true };
  }

  if (item.regexp !== null) {
    try {
      const regexp = new RegExp(item.regexp);
      if (!regexp.test(value)) {
        return { isValid: false, type: 'format' };
      }
    } catch (e) {} // eslint-disable-line no-empty
  }

  if (item.validation_type !== null) {
    switch (item.validation_type) {
      case 'alphanumeric':
        if (!regexpAlphanumeric.test(value)) {
          return { isValid: false, type: 'format' };
        }
        break;
      case 'numeric':
        if (!regexpNumeric.test(value)) {
          return { isValid: false, type: 'format' };
        }
        break;
      case 'phone':
        if (!regexpPhone.test(value)) {
          return { isValid: false, type: 'format' };
        }
        break;
      case 'email':
        if (!regexpEmail.test(value)) {
          return { isValid: false, type: 'format' };
        }
        break;
      case 'katakana':
        if (!regexpKatakana.test(value)) {
          return { isValid: false, type: 'format' };
        }
    }
  }

  return { isValid: true };
};
